//GLOBAL VARIABLE ** USE THIS INSTAED OF CREATING AGAIN AND AGIAN :) **
var WINDOW_WIDTH = $(window).width();

$(function () {
  announcementBarSlider();
  featuredHomeCollectionSlider();
  testimonialSlider();
  logoListSlider();
  footerMobileAccordian();
  productAccordian();
  productV2MainSlider();

  //close menu drawer
  $("[data-close-menu]").on("click", function (e) {
    e.preventDefault();
    $('header .header__icon--summary[aria-expanded="true"]').trigger("click");
  });
  //close menu drawer - end

  //scroll to review widget when star click
  $(".template--product .star-widget-wraper").click(function () {
    $("html, body").animate(
      {
        scrollTop: $("#stamped-main-widget").offset().top,
      },
      1500
    );
  });
  //END -scroll to review widget when star click

  $(".No-review-fix").each(function (ind, ele) {
    var selector = ".stamped-badge-caption";
    var isALARendered;
    ALAcheck(selector, ele, isALARendered);
  });

  function ALAcheck(selector, ele, isALARendered) {
    isALARendered = setInterval(function () {
      customALA(selector, ele, isALARendered);
    }, 2000);
  }

  function customALA(selector, ele, isALARendered) {
    if (
      $(ele).siblings(".stamped-product-reviews-badge").find(selector).length >
      0
    ) {
      clearInterval(isALARendered);
      var badge_html = $(ele).siblings(".stamped-product-reviews-badge");
      var html_merge = `<span class="stamped-avg-rating">${$(badge_html)
        .find(".stamped-badge-caption")
        .attr("data-rating")} </span><span class="stamped-total-rating">(${$(
        badge_html
      )
        .find(".stamped-badge-caption")
        .attr("data-reviews")} ${$(badge_html)
        .find(".stamped-badge-caption")
        .attr("data-label")})</span>`;
      $(badge_html).find(".stamped-starrating i").removeAttr("style");
      $(ele).closest(".star-widget-wraper").removeClass("No-display");
      $(ele).empty().append(html_merge);
    }
  }

  // For video overview section on PDP
  setTimeout(function () {
    if ($(".product-v2 .reeview-app-widget").children().length <= 0) {
      $(".product-v2 .video_overview").hide();
    }
  }, 2000);
  //END -For video overview section on PDP

  // Set roduct overview on mobile view
  if (WINDOW_WIDTH < 749) {
    var video_html = $(".product-v2 .video_overview").html();
    //console.log(video_html);
    $(".product-v2 .video_overview").remove();
    $(".product-v2 .mobile_video_overview").html(
      '<div class="video_overview">' + video_html + "</div>"
    );
  }
  // END - Set product overview on mobile view

  // Click on icon, play video in Product Overview section
  $(".product-v2 .video_overview .link_icon").click(function () {
    $(".vw-cmp__video-card--play-icon .needsclick").trigger("click");
  });
  // END - Click on icon play video in Product Overview section

  // Summary description of Product
  $(".product-v2 .P_show").on("click", function () {
    $(this).closest(".product_short_desc").find(".More_description").hide();
    $(this).closest(".product_short_desc").find(".Less_description").show();
  });

  $(".product-v2 .P_less").on("click", function () {
    $(this).closest(".product_short_desc").find(".Less_description").hide();
    $(this).closest(".product_short_desc").find(".More_description").show();
  });
  if ($(".product-v2 .product_short_desc:empty").length > 0) {
    $(".product__info-container").addClass("product_short_desc_empty");
  }
  // END - Summary description of Product

  // Affirm price

  var affirmPriceSetUp;
  var affirmPriceSetUpcart;
  setTimeout(function () {
    affirmPriceSetUp = setInterval(affrimSetup, 1000);
    affirmPriceSetUpcart = setInterval(affrimSetupcart, 1000);
  }, 1600);

  function affrimSetup() {
    if (
      $(".paybright-widget-container").children().length > 0 ||
      $(".paybright-widget-container+.custom_paybright").length > 0
    ) {
      let temp = 0;
      let affirmPrice_text = $(
        ".product-v2 .paybright-widget-container"
      ).text();
      let textArray = affirmPrice_text.split(" ");
      var arrayText = [];
      $.each(textArray, function (key, value) {
        if (value.includes("$")) {
          var price = value;
          arrayText.push(price);
        }
        if (value.includes("bi-weekly")) {
          var time = "Weekly:";
          arrayText.push(time);
        } else if (value.includes("bi-monthly")) {
          var time = "Monthly:";
          arrayText.push(time);
        } else {
          temp++;
        }
      });
      if (textArray.length == temp) arrayText[1] = "";

      /*var svg_logo= '<svg width="40" height="14" viewBox="0 0 40 14" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_19_1699)"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.685 7.88862C2.63571 7.88862 1.41929 8.34131 0.76 8.81077L1.36357 9.95089C1.89286 9.51497 2.74714 9.1461 3.51786 9.1461C4.25143 9.1461 4.65071 9.36407 4.65071 9.80838C4.65071 10.1102 4.38143 10.2611 3.88 10.3198C1.98571 10.5377 0.5 11.0072 0.5 12.3233C0.5 13.3629 1.32643 14 2.60786 14C3.52714 14 4.34429 13.5389 4.73429 12.9353V13.8323H6.44286V10.0683C6.44286 8.51736 5.245 7.88862 3.685 7.88862ZM3.04429 12.7928C2.56143 12.7928 2.32 12.5832 2.32 12.2311C2.32 11.5772 3.12786 11.3593 4.60429 11.2168C4.61357 12.0886 3.95429 12.7928 3.04429 12.7928Z" fill="#101820"/><path fill-rule="evenodd" clip-rule="evenodd" d="M22.5536 9.02874V8.05628H20.845V13.8323H22.6743V11.0491C22.6743 9.72455 23.5564 9.33892 24.1786 9.33892C24.42 9.33892 24.745 9.40598 24.9586 9.5485L25.2929 8.02275C25.0143 7.91377 24.7171 7.88862 24.4757 7.88862C23.5379 7.88862 22.9436 8.26586 22.5536 9.02874Z" fill="#101820"/><path fill-rule="evenodd" clip-rule="evenodd" d="M33.78 7.88862C32.8143 7.88862 32.09 8.40838 31.7093 8.90299C31.3564 8.25748 30.6229 7.88862 29.7314 7.88862C28.7657 7.88862 28.0971 8.37485 27.7814 8.92814V8.05628H26.0171V13.8323H27.8464V10.8563C27.8464 9.79161 28.4686 9.28023 29.0443 9.28023C29.5643 9.28023 30.0471 9.58203 30.0471 10.3701V13.8323H31.8857V10.8563C31.8857 9.77485 32.4893 9.28023 33.0929 9.28023C33.5757 9.28023 34.0864 9.5988 34.0864 10.3617V13.8323H35.9157V9.84191C35.9157 8.54251 34.95 7.88862 33.78 7.88862Z" fill="#101820"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.9057 7.62874V8.05628H10.1293V7.46946C10.1293 6.70658 10.6121 6.48862 11.03 6.48862C11.2714 6.48862 11.5871 6.53892 11.8471 6.67305L12.4136 5.50778C12.0793 5.33173 11.5314 5.17245 10.7979 5.17245C9.62786 5.17245 8.3 5.76766 8.3 7.63712V8.06467H7.24143V9.33892H8.3V13.8323H10.1293V9.33053H12.9057V13.8323H14.735V9.33053H16.3971V8.05628H14.735V7.46946C14.735 6.70658 15.2179 6.48862 15.6357 6.48862C16.1 6.48862 16.4529 6.67305 16.4529 6.67305L17.0193 5.50778C17.0193 5.50778 16.4436 5.17245 15.4036 5.17245C14.2429 5.16407 12.9057 5.75928 12.9057 7.62874Z" fill="#101820"/><path fill-rule="evenodd" clip-rule="evenodd" d="M17.4836 8.05628H19.3129V13.8323H17.4836V8.05628Z" fill="#101820"/><path fill-rule="evenodd" clip-rule="evenodd" d="M28.1443 0C23.2043 0 18.8029 3.09341 17.5586 7.07545H19.3507C20.3907 4.10778 23.9286 1.50898 28.1443 1.50898C33.27 1.50898 37.69 5.02994 37.69 10.5126C37.69 11.7449 37.5136 12.8515 37.1793 13.8323H38.9157L38.9343 13.782C39.2222 12.7677 39.3615 11.6695 39.3615 10.5126C39.3615 4.4012 34.4307 0 28.1443 0Z" fill="#4A4AF4"/></g><defs><clipPath id="clip0_19_1699"><rect width="39" height="14" fill="white" transform="translate(0.5)"/></clipPath></defs></svg>';
      var svg_learnMore = '<svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.5 0C3.1838 0 0.5 2.6835 0.5 6C0.5 9.31615 3.1835 12 6.5 12C9.8162 12 12.5 9.3165 12.5 6C12.5 2.6838 9.8165 0 6.5 0ZM6.32246 8.80826C5.98285 8.80826 5.72223 8.52394 5.72223 8.2001C5.72223 7.86839 5.99075 7.59199 6.32246 7.59199C6.6542 7.59199 6.93057 7.86841 6.93057 8.20013C6.93057 8.52391 6.66205 8.80826 6.32246 8.80826ZM7.22279 5.736C6.78842 6.07561 6.7805 6.31254 6.7805 6.72321C6.7805 6.8733 6.70152 7.04705 6.31454 7.04705C5.9907 7.04705 5.88017 6.92857 5.88017 6.5179C5.88017 5.83868 6.18029 5.51487 6.40932 5.31743C6.66995 5.09627 7.11223 4.85147 7.11223 4.425C7.11223 4.06167 6.79632 3.88793 6.40142 3.88793C5.59585 3.88793 5.76962 4.49609 5.3431 4.49609C5.12987 4.49609 4.86924 4.35389 4.86924 4.0459C4.86924 3.61943 5.3589 2.98758 6.42512 2.98758C7.43602 2.98758 8.10734 3.54834 8.10734 4.29073C8.10734 5.03311 7.43602 5.57016 7.22279 5.736Z" fill="#676870"/></svg>';
      $('.product-v2 .paybright-widget-container').after('<div class="custom_paybright"><div class="buynow_text">Pay '+ arrayText[1] +'</div><span class="price">'+arrayText[0]+'</span> <div class="icon-inline">with'+svg_logo +'<span class="learn_more">'+svg_learnMore+'</span></div></div>');*/
      $(
        ".product-v2 .paybright-widget-container+.custom_paybright.hidden"
      ).removeClass("hidden");

      $(".product-v2 .learn_more").click(function () {
        $(".product-v2 .paybright-widget-container a")[0].click();
      });
      clearInterval(affirmPriceSetUp);
    } else {
      clearInterval(affirmPriceSetUp);
    }
  }
  function affrimSetupcart() {
    if ($("#CartDrawer #paybright-widget-container").children().length > 0) {
      // $('#paybright-widget-container p a').prepend('<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"><g><g><path fill="#676870" d="M12 6c0 3.317-2.684 6-6 6-3.317 0-6-2.684-6-6 0-3.317 2.684-6 6-6 3.317 0 6 2.684 6 6zM6.43 8.2a.613.613 0 0 0-.608-.608c-.331 0-.6.276-.6.608 0 .324.26.608.6.608.34 0 .609-.284.609-.608zm1.177-3.91c0-.742-.671-1.302-1.682-1.302-1.066 0-1.556.631-1.556 1.058 0 .308.26.45.474.45.427 0 .253-.608 1.058-.608.395 0 .711.174.711.537 0 .426-.442.671-.703.892-.229.198-.529.522-.529 1.2 0 .412.11.53.435.53.387 0 .465-.174.465-.324 0-.41.008-.647.443-.987.213-.166.884-.703.884-1.445z"/></g></g></svg>');
      var split_html = $("#CartDrawer #paybright-widget-container p")
        .html()
        .split("<img");
      $("#CartDrawer #paybright-widget-container").text("");
      $("#CartDrawer #paybright-widget-container").html(
        '<div class="cont">' +
          split_html[0] +
          '</div><div class="pay-bright"><svg xmlns="http://www.w3.org/2000/svg" width="108" height="14" viewBox="0 0 108 14"><g><g><path fill="#4a4af4" d="M12.446 3.174c1.077 0 1.976.456 2.35 1.1v-.58a.283.283 0 0 1 .094-.224.322.322 0 0 1 .239-.087h1.402a.345.345 0 0 1 .238.088.288.288 0 0 1 .096.222v6.605a.29.29 0 0 1-.096.222.331.331 0 0 1-.238.09H15.13a.345.345 0 0 1-.237-.09.306.306 0 0 1-.072-.102.287.287 0 0 1-.023-.12v-.57c-.411.653-1.274 1.098-2.37 1.098C10.42 10.826 8.57 9.335 8.57 7s1.849-3.826 3.876-3.826zm.288 5.848c1.198 0 2.063-.902 2.063-2.033 0-1.131-.865-2.022-2.063-2.022a2.231 2.231 0 0 0-.809.16 2.116 2.116 0 0 0-.68.44 1.961 1.961 0 0 0-.448.65c-.102.243-.15.502-.145.763 0 1.133.909 2.042 2.082 2.042zM8.297 6.98c0 2.332-1.793 3.826-3.832 3.826-.94 0-1.905-.353-2.37-1.006l-.023 3.464v.093a.288.288 0 0 1-.095.221.33.33 0 0 1-.236.09H.33a.346.346 0 0 1-.236-.09.288.288 0 0 1-.095-.221V3.693a.288.288 0 0 1 .095-.221.328.328 0 0 1 .237-.09h1.383a.342.342 0 0 1 .243.086.284.284 0 0 1 .097.225v.58c.45-.643 1.33-1.1 2.426-1.1 2.036 0 3.816 1.474 3.816 3.807zm-2.09 0c0-1.12-.863-2.023-2.06-2.023-.281.001-.559.055-.817.158a2.101 2.101 0 0 0-.686.444c-.195.19-.346.414-.446.66-.1.245-.146.507-.135.77 0 1.131.898 2.033 2.084 2.033 1.197 0 2.06-.922 2.06-2.042zm18.586-3.588c.298 0 .4.177.322.492L22.8 10.612l-.943 2.403-.098.342a.381.381 0 0 1-.145.225.429.429 0 0 1-.266.085H19.84c-.31 0-.399-.175-.288-.465l1.075-2.603h-.553a.45.45 0 0 1-.263-.09.403.403 0 0 1-.148-.22l-2.337-6.43c-.08-.249-.034-.467.331-.467h1.64a.38.38 0 0 1 .231.096.336.336 0 0 1 .11.213l1.619 4.966.964-2.796.654-2.167a.383.383 0 0 1 .145-.226.431.431 0 0 1 .266-.086zm14.019-.124c.177 0 .365.072.365.384v1.294a.335.335 0 0 1-.104.276.383.383 0 0 1-.291.109h-.395c-1.02 0-1.618.486-1.618 1.73v3.237a.287.287 0 0 1-.102.21.324.324 0 0 1-.23.08H35.03a.346.346 0 0 1-.23-.092.289.289 0 0 1-.093-.219V3.662a.284.284 0 0 1 .094-.223.328.328 0 0 1 .24-.088h1.329a.335.335 0 0 1 .23.081c.062.055.098.13.102.21v.683c.184-.32.457-.588.79-.776a2.285 2.285 0 0 1 1.104-.292c.072.01.144.013.216.011zm.577-2.074a1.15 1.15 0 0 1 .22-.665c.143-.196.344-.35.578-.44a1.37 1.37 0 0 1 .741-.065c.248.046.477.16.656.328.18.168.301.382.352.614.05.233.025.474-.071.694-.096.219-.26.407-.47.54a1.348 1.348 0 0 1-1.627-.149 1.174 1.174 0 0 1-.38-.857zm.592 9.385a.355.355 0 0 1-.237-.091.294.294 0 0 1-.099-.221V3.661a.283.283 0 0 1 .094-.223.326.326 0 0 1 .238-.088h1.383a.339.339 0 0 1 .239.088.284.284 0 0 1 .093.223v6.584a.311.311 0 0 1-.1.218.353.353 0 0 1-.232.094h-1.383zM66.418 9.51a.351.351 0 0 1-.058.497c-.509.477-1.295.727-2.182.727-1.263 0-2.559-.643-2.559-2.272V4.983h-1.065a.346.346 0 0 1-.237-.09.3.3 0 0 1-.095-.222v-.994a.292.292 0 0 1 .092-.223.327.327 0 0 1 .235-.094h1.064V1.847a.28.28 0 0 1 .093-.224.337.337 0 0 1 .239-.087h1.407a.342.342 0 0 1 .243.085c.032.03.057.065.073.103.017.04.025.08.024.123V3.34h2.238c.088 0 .172.034.235.092a.303.303 0 0 1 .097.22v.995a.309.309 0 0 1-.1.217.35.35 0 0 1-.232.093h-2.238v3.054c0 .708.519.924.885.924.261-.005.515-.08.732-.216.226-.146.487-.146.62.052zm-17.622.093c-.395.582-1.252 1.027-2.337 1.027-2.118 0-3.902-1.41-3.902-3.734 0-2.323 1.818-3.752 3.823-3.752 1.098 0 2.029.466 2.416 1.098v-.58a.292.292 0 0 1 .096-.222.344.344 0 0 1 .236-.09h1.383a.341.341 0 0 1 .238.089.296.296 0 0 1 .094.223v6.948c0 2-1.58 3.39-4.149 3.39-2.06 0-3.568-1.224-3.933-2.603a.217.217 0 0 1 .001-.188.23.23 0 0 1 .062-.076.248.248 0 0 1 .09-.046h1.52c.197 0 .31.02.365.124.176.54.775 1.1 1.929 1.1 1.412.03 2.068-.675 2.068-1.753zm-2.072-.684c1.197 0 2.062-.85 2.062-1.98s-.865-1.982-2.062-1.982a2.166 2.166 0 0 0-.805.147c-.255.1-.486.247-.679.432a1.901 1.901 0 0 0-.442.646c-.1.241-.145.499-.135.757 0 1.13.875 1.98 2.06 1.98zM30.3 3.122c1.993 0 3.833 1.484 3.833 3.817s-1.83 3.826-3.859 3.826c-1.096 0-1.928-.445-2.37-1.1v.58a.29.29 0 0 1-.096.223.331.331 0 0 1-.236.09H26.19a.344.344 0 0 1-.237-.09.288.288 0 0 1-.095-.223V2.668L25.836.623A.298.298 0 0 1 25.93.4a.323.323 0 0 1 .24-.088h1.382a.354.354 0 0 1 .233.093.31.31 0 0 1 .1.218l.023 2.044V4.19c.387-.6 1.296-1.068 2.394-1.068zm1.762 3.826c.006-.26-.044-.52-.145-.762a1.962 1.962 0 0 0-.448-.65 2.117 2.117 0 0 0-.681-.44 2.232 2.232 0 0 0-.81-.16c-1.175 0-2.06.89-2.06 2.021 0 1.132.885 2.034 2.06 2.034 1.171 0 2.06-.912 2.084-2.043zm24.613-3.826c2.04 0 3.317 1.35 3.28 3.142v4.002a.285.285 0 0 1-.101.21.327.327 0 0 1-.23.082H58.24a.34.34 0 0 1-.23-.081.303.303 0 0 1-.074-.096.284.284 0 0 1-.028-.115V6.784c0-1.139-.675-1.878-1.873-1.878-1.153 0-1.928.758-1.928 1.878v3.482a.296.296 0 0 1-.101.21.337.337 0 0 1-.23.082h-1.409a.346.346 0 0 1-.237-.09.303.303 0 0 1-.095-.222V.634a.29.29 0 0 1 .095-.221.345.345 0 0 1 .237-.09h1.408a.335.335 0 0 1 .23.081c.062.055.1.13.102.21V4.19c.45-.58 1.338-1.068 2.568-1.068zM72.212 5.32h.646V7.25h.054c.108-.211.282-.388.497-.508.216-.12.465-.178.716-.166 1.059 0 1.79.787 1.79 2.022 0 1.235-.731 2.033-1.779 2.033-.253.01-.504-.05-.72-.172a1.248 1.248 0 0 1-.503-.514h-.078v.603h-.623zm1.835 4.772c.808 0 1.223-.665 1.223-1.502 0-.838-.395-1.48-1.223-1.48-.79 0-1.2.594-1.2 1.48 0 .885.426 1.502 1.2 1.502zm2.81 1.318c.47.113.764.056.988-.532l.126-.307-1.55-3.937h.699l1.157 3.126h.044l1.157-3.126h.704l-1.778 4.486c-.241.6-.654.89-1.235.89a1.323 1.323 0 0 1-.476-.07zM84.2 9.854c.597 0 1.023-.48 1.023-1.074-.966.096-1.495.248-1.495.691 0 .239.156.383.472.383zm.409-3.33c1.015 0 1.806.424 1.806 1.48v2.556h-1.12v-.61a1.582 1.582 0 0 1-.591.532 1.713 1.713 0 0 1-.792.194c-.844 0-1.383-.428-1.383-1.138 0-.895.971-1.213 2.212-1.364.332-.04.508-.143.508-.348 0-.301-.265-.45-.745-.45a2.35 2.35 0 0 0-1.41.554l-.396-.777a3.582 3.582 0 0 1 1.919-.626zm12.38.11v.658c.095-.238.268-.442.495-.581.227-.14.495-.207.766-.193.184-.004.367.027.537.09l-.219 1.037a.964.964 0 0 0-.511-.14c-.396 0-.988.262-.988 1.162v1.891h-1.2V6.634zm7.366-.115c.766 0 1.4.446 1.4 1.328v2.711h-1.199V8.205c0-.523-.334-.74-.65-.74-.395 0-.79.335-.79 1.075v2.018h-1.197V8.205c0-.53-.316-.74-.66-.74-.383 0-.791.348-.791 1.075v2.018H99.27V6.634h1.155v.595c.128-.212.313-.39.537-.514a1.56 1.56 0 0 1 1.485-.012c.227.12.415.295.546.506.15-.209.352-.38.587-.5.237-.12.5-.186.769-.19zm-11.401.982h-1.087v3.057h-1.199V7.501h-1.817v3.057h-1.2V7.501h-.693v-.867h.695v-.298c0-1.258.871-1.663 1.638-1.663.368-.012.732.067 1.057.229l-.37.791a1.22 1.22 0 0 0-.537-.126c-.276 0-.593.15-.593.67v.397h1.818v-.298c0-1.258.873-1.663 1.64-1.663.368-.014.733.065 1.057.229l-.372.791a1.253 1.253 0 0 0-.535-.126c-.275 0-.593.15-.593.67v.397h1.087zm.71-.867h1.2v3.924h-1.2zm6.988-5.473c-3.237 0-6.124 2.103-6.942 4.806h1.174c.684-2.015 3.005-3.782 5.768-3.782 3.359 0 6.259 2.392 6.259 6.116a7.176 7.176 0 0 1-.334 2.255h1.138l.012-.037A8.51 8.51 0 0 0 108 8.298c0-4.154-3.234-7.143-7.355-7.143"/></g></g></svg> <a href="javascript:void(0);" class="info"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"><g><g><path fill="#676870" d="M12 6c0 3.317-2.684 6-6 6-3.317 0-6-2.684-6-6 0-3.317 2.684-6 6-6 3.317 0 6 2.684 6 6zM6.43 8.2a.613.613 0 0 0-.608-.608c-.331 0-.6.276-.6.608 0 .324.26.608.6.608.34 0 .609-.284.609-.608zm1.177-3.91c0-.742-.671-1.302-1.682-1.302-1.066 0-1.556.631-1.556 1.058 0 .308.26.45.474.45.427 0 .253-.608 1.058-.608.395 0 .711.174.711.537 0 .426-.442.671-.703.892-.229.198-.529.522-.529 1.2 0 .412.11.53.435.53.387 0 .465-.174.465-.324 0-.41.008-.647.443-.987.213-.166.884-.703.884-1.445z"/></g></g></svg></a></div><a data-pb_open_modal href="#" class="more"> Learn more</a>'
      );
      var append_html = $("#paybright-widget-container").html();
      $(".intrest-free-payment").append(
        '<div id="paybright-widget-container" class="active">' +
          append_html +
          "</div>"
      );
      clearInterval(affirmPriceSetUpcart);
    } else {
      clearInterval(affirmPriceSetUpcart);
    }
  }

  // setTimeout(function(){
  //    let affirmPrice_text = $('.product-v2 .paybright-widget-container').text();
  //    let textArray = affirmPrice_text.split(" ");
  //    var arrayText = [];
  //      $.each( textArray, function( key, value ) {
  //        if(value.includes('$'))
  //        {
  //          var price = value;
  //          arrayText.push(price);
  //        }
  //        if(value.includes('bi-weekly'))
  //        {
  //          var time = 'Weekly:';
  //          arrayText.push(time);
  //        }
  //        else if(value.includes('bi-monthly')){
  //          var time = 'Monthly:';
  //          arrayText.push(time);
  //        }
  //    });

  //      var svg_logo= '<svg width="40" height="14" viewBox="0 0 40 14" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_19_1699)"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.685 7.88862C2.63571 7.88862 1.41929 8.34131 0.76 8.81077L1.36357 9.95089C1.89286 9.51497 2.74714 9.1461 3.51786 9.1461C4.25143 9.1461 4.65071 9.36407 4.65071 9.80838C4.65071 10.1102 4.38143 10.2611 3.88 10.3198C1.98571 10.5377 0.5 11.0072 0.5 12.3233C0.5 13.3629 1.32643 14 2.60786 14C3.52714 14 4.34429 13.5389 4.73429 12.9353V13.8323H6.44286V10.0683C6.44286 8.51736 5.245 7.88862 3.685 7.88862ZM3.04429 12.7928C2.56143 12.7928 2.32 12.5832 2.32 12.2311C2.32 11.5772 3.12786 11.3593 4.60429 11.2168C4.61357 12.0886 3.95429 12.7928 3.04429 12.7928Z" fill="#101820"/><path fill-rule="evenodd" clip-rule="evenodd" d="M22.5536 9.02874V8.05628H20.845V13.8323H22.6743V11.0491C22.6743 9.72455 23.5564 9.33892 24.1786 9.33892C24.42 9.33892 24.745 9.40598 24.9586 9.5485L25.2929 8.02275C25.0143 7.91377 24.7171 7.88862 24.4757 7.88862C23.5379 7.88862 22.9436 8.26586 22.5536 9.02874Z" fill="#101820"/><path fill-rule="evenodd" clip-rule="evenodd" d="M33.78 7.88862C32.8143 7.88862 32.09 8.40838 31.7093 8.90299C31.3564 8.25748 30.6229 7.88862 29.7314 7.88862C28.7657 7.88862 28.0971 8.37485 27.7814 8.92814V8.05628H26.0171V13.8323H27.8464V10.8563C27.8464 9.79161 28.4686 9.28023 29.0443 9.28023C29.5643 9.28023 30.0471 9.58203 30.0471 10.3701V13.8323H31.8857V10.8563C31.8857 9.77485 32.4893 9.28023 33.0929 9.28023C33.5757 9.28023 34.0864 9.5988 34.0864 10.3617V13.8323H35.9157V9.84191C35.9157 8.54251 34.95 7.88862 33.78 7.88862Z" fill="#101820"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.9057 7.62874V8.05628H10.1293V7.46946C10.1293 6.70658 10.6121 6.48862 11.03 6.48862C11.2714 6.48862 11.5871 6.53892 11.8471 6.67305L12.4136 5.50778C12.0793 5.33173 11.5314 5.17245 10.7979 5.17245C9.62786 5.17245 8.3 5.76766 8.3 7.63712V8.06467H7.24143V9.33892H8.3V13.8323H10.1293V9.33053H12.9057V13.8323H14.735V9.33053H16.3971V8.05628H14.735V7.46946C14.735 6.70658 15.2179 6.48862 15.6357 6.48862C16.1 6.48862 16.4529 6.67305 16.4529 6.67305L17.0193 5.50778C17.0193 5.50778 16.4436 5.17245 15.4036 5.17245C14.2429 5.16407 12.9057 5.75928 12.9057 7.62874Z" fill="#101820"/><path fill-rule="evenodd" clip-rule="evenodd" d="M17.4836 8.05628H19.3129V13.8323H17.4836V8.05628Z" fill="#101820"/><path fill-rule="evenodd" clip-rule="evenodd" d="M28.1443 0C23.2043 0 18.8029 3.09341 17.5586 7.07545H19.3507C20.3907 4.10778 23.9286 1.50898 28.1443 1.50898C33.27 1.50898 37.69 5.02994 37.69 10.5126C37.69 11.7449 37.5136 12.8515 37.1793 13.8323H38.9157L38.9343 13.782C39.2222 12.7677 39.3615 11.6695 39.3615 10.5126C39.3615 4.4012 34.4307 0 28.1443 0Z" fill="#4A4AF4"/></g><defs><clipPath id="clip0_19_1699"><rect width="39" height="14" fill="white" transform="translate(0.5)"/></clipPath></defs></svg>';
  //      var svg_learnMore = '<svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.5 0C3.1838 0 0.5 2.6835 0.5 6C0.5 9.31615 3.1835 12 6.5 12C9.8162 12 12.5 9.3165 12.5 6C12.5 2.6838 9.8165 0 6.5 0ZM6.32246 8.80826C5.98285 8.80826 5.72223 8.52394 5.72223 8.2001C5.72223 7.86839 5.99075 7.59199 6.32246 7.59199C6.6542 7.59199 6.93057 7.86841 6.93057 8.20013C6.93057 8.52391 6.66205 8.80826 6.32246 8.80826ZM7.22279 5.736C6.78842 6.07561 6.7805 6.31254 6.7805 6.72321C6.7805 6.8733 6.70152 7.04705 6.31454 7.04705C5.9907 7.04705 5.88017 6.92857 5.88017 6.5179C5.88017 5.83868 6.18029 5.51487 6.40932 5.31743C6.66995 5.09627 7.11223 4.85147 7.11223 4.425C7.11223 4.06167 6.79632 3.88793 6.40142 3.88793C5.59585 3.88793 5.76962 4.49609 5.3431 4.49609C5.12987 4.49609 4.86924 4.35389 4.86924 4.0459C4.86924 3.61943 5.3589 2.98758 6.42512 2.98758C7.43602 2.98758 8.10734 3.54834 8.10734 4.29073C8.10734 5.03311 7.43602 5.57016 7.22279 5.736Z" fill="#676870"/></svg>';
  //     $('.product-v2 .paybright-widget-container').after('<div class="custom_paybright"><div class="buynow_text">Pay '+ arrayText[1] +'</div><span class="price">'+arrayText[0]+'</span> <div class="icon-inline">with'+svg_logo +'<span class="learn_more">'+svg_learnMore+'</span></div></div>');

  //      $('.product-v2 .learn_more').click(function(){
  //        $('.product-v2 .paybright-widget-container a')[0].click();
  //      })
  //   }, 5000);
  // END - Affirm price

  /* Sticky add tocart js */

  let sticky_btn = document.querySelector(".atcbar .atc-btn2");
  if (sticky_btn) {
    sticky_btn.addEventListener("click", function () {
      document.querySelector(".product-form .product-form__submit").click();
    });
  } else {
    let btn_parent = document.querySelector(".atcbar.custom");
    if (btn_parent) {
      btn_parent.style.display = "none";
      btn_parent.style.opacity = "0";
    }
  }

  window.addEventListener("scroll", function () {
    var distanceFromTop = $(document).scrollTop();
    if (distanceFromTop >= 200) {
      jQuery("div.atcbar.custom").fadeIn(400).removeClass("hidden");
      jQuery("body").addClass("enable-add-to-sticky");
    } else {
      jQuery("div.atcbar.custom").fadeOut(400).addClass("hidden");
      jQuery("body").removeClass("enable-add-to-sticky");
    }
  });
  /* Sticky add tocart js */
});

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function announcementBarSlider() {
  let announcementBarContainer = $(
    ".announcement-bar-new [data-announcement-bar-slider]"
  );
  if (!announcementBarContainer.length) return;
  $(announcementBarContainer).not(".slick-initialized").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 2500,
    infinite: true,
    draggable: false,
    pauseOnHover: false,
    swipe: false,
    touchMove: false,
    cssEase: "linear",
    arrows: false,
    centerMode: true,
    variableWidth: true,
  });
}

function logoListSlider() {
  let logoListContainer = $(".featured-logo-list [data-logo-slider]");
  if (!logoListContainer.length) return;
  $(logoListContainer).not(".slick-initialized").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 1800,
    infinite: true,
    draggable: false,
    pauseOnHover: true,
    swipe: false,
    touchMove: false,
    cssEase: "linear",
    arrows: false,
    centerMode: true,
    centerPadding: "0px",
    variableWidth: true,
  });
}

function featuredHomeCollectionSlider(windowWidth = WINDOW_WIDTH) {
  let featuredCollectionContainer = $(
    ".featured-collection-slider [data-colletion-slider]"
  );
  if (!featuredCollectionContainer.length) return;
  if (windowWidth > 749) {
    $(featuredCollectionContainer)
      .not(".slick-initialized")
      .slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: false,
        arrows: true,
        dots: false,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
        ],
      });
  } else {
    if ($(featuredCollectionContainer).hasClass("slick-initialized")) {
      $(featuredCollectionContainer).slick("unslick");
    }
  }
  updateSliderStyle((windowWidth = WINDOW_WIDTH));
}

function updateSliderStyle(windowWidth = WINDOW_WIDTH) {
  if (windowWidth < 750) return;
  let featuredCollectionContainer = $(
    ".featured-collection-slider [data-colletion-slider]"
  );
  if (!featuredCollectionContainer.length) return;
  let firstContainerLeftArea = $("body main .page-width").eq(1).offset().left;
  $(featuredCollectionContainer)
    .closest(".slider-component-wrap")
    .css("padding-left", firstContainerLeftArea);
}

function testimonialSlider(windowWidth = WINDOW_WIDTH) {
  let testimonialSliderContainer = $(".testimonial [data-review-slider]");
  if (!testimonialSliderContainer.length) return;
  if (windowWidth > 749) {
    $(testimonialSliderContainer)
      .not(".slick-initialized")
      .slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        dots: false,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      });
  } else {
    if ($(testimonialSliderContainer).hasClass("slick-initialized")) {
      $(testimonialSliderContainer).slick("unslick");
    }
  }
}

function productV2MainSlider(windowWidth = WINDOW_WIDTH) {
  let productV2MainSliderEle = $(".product-v2 .product__mainImage") || null;
  let productV2ThumbSliderEle = $(".product-v2 .product__thumbImages") || null;
  if (!productV2MainSliderEle.length && productV2ThumbSliderEle.length) return;
  if (windowWidth > 749) {
    $(productV2MainSliderEle).not(".slick-initialized").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: ".product__thumbImages",
    });
    $(productV2ThumbSliderEle).not(".slick-initialized").slick({
      slidesToShow: 7,
      slidesToScroll: 1,
      asNavFor: ".product__mainImage",
      dots: true,
      centerMode: false,
      vertical: true,
      focusOnSelect: true,
    });

    if ($(productV2MainSliderEle).find(".current_featred").length > 0) {
      $(productV2MainSliderEle).slick(
        "slickGoTo",
        Number(
          $(productV2MainSliderEle)
            .find(".current_featred")
            .attr("data-slick-index")
        )
      );
    }
  } else {
    if (
      $(productV2MainSliderEle).hasClass("slick-initialized") &&
      $(productV2ThumbSliderEle).hasClass("slick-initialized")
    ) {
      $(productV2MainSliderEle).slick("unslick");
      $(productV2ThumbSliderEle).slick("unslick");
    }
  }
}

function productAccordian() {
  if ($("body.template--product").length) {
    $(".template--product #pro-accordion .accordion-box .title").click(
      function () {
        if ($(this).closest(".panel").length > 0) {
          $(this)
            .closest(".panel")
            .find(".panel")
            .not($(this).next())
            .slideUp(400);
          $(".panel .active").not(this).removeClass("active");
          $(this).toggleClass("active");
          $(this).next().slideToggle(400);
        } else {
          $("#pro-accordion").find(".panel").not($(this).next()).slideUp(400);
          $(".active").not(this).removeClass("active");
          $(this).toggleClass("active");
          $(this).next().slideToggle(400);
        }
      }
    );
  }
}

function footerMobileAccordian(windowWidth = WINDOW_WIDTH) {
  if (windowWidth < 750) {
    $(".footer-block__heading > a").on("click", function (e) {
      e.preventDefault();
      if ($(this).closest(".footer-block--menu").hasClass("active")) {
        $(this)
          .closest(".footer-block--menu")
          .find("ul.footer-block__details-content")
          .slideUp(500);
        $(this).closest(".footer-block--menu").removeClass("active");
      } else {
        $(".footer-block--menu").removeClass("active");
        $(this).closest(".footer-block--menu").addClass("active");
        $("ul.footer-block__details-content").slideUp(500);
        $(this)
          .closest(".footer-block--menu")
          .find("ul.footer-block__details-content")
          .slideDown(500);
      }
    });
  }
}

function screenResizeObsever() {
  const featuredCollectionContainer = document.querySelectorAll(
    ".featured-collection-slider [data-colletion-slider]"
  );
  const testimonialSliderContainer =
    document.querySelector(".testimonial [data-review-slider]") || null;
  var ro = new ResizeObserver(
    debounce((entries) => {
      let windowWidth = document.body.getBoundingClientRect().width;
      if (featuredCollectionContainer.length) {
        featuredHomeCollectionSlider(windowWidth);
        updateSliderStyle(windowWidth);
      }
      if (testimonialSliderContainer) {
        testimonialSlider(windowWidth);
      }
    }, 225)
  );

  // Observe one or multiple elements
  if (featuredCollectionContainer.length) {
    featuredCollectionContainer.forEach((ele) => ro.observe(ele));
  }
  if (testimonialSliderContainer) {
    ro.observe(testimonialSliderContainer);
  }
}

window.addEventListener("load", function () {
  screenResizeObsever();
});

// window resize
window.addEventListener(
  "resize",
  debounce(function () {
    // console.log("resize",window.outerWidth);
    var outerWidth =
      window.outerWidth > 0 ? window.outerWidth : window.innerWidth;
    let product_videowise_mobile = document.querySelectorAll(
      ".mobile_video_overview"
    );
    // console.log("product_videowise_mobile",product_videowise_mobile);
    // console.log(product_videowise_mobile[0].innerHTML);
    if (
      product_videowise_mobile.length === 1 &&
      product_videowise_mobile[0].innerHTML == "" &&
      outerWidth < 749
    ) {
      //location.reload();
    }
  })
);

// This will only render in the theme editor
if (Shopify.designMode) {
  document.addEventListener("DOMContentLoaded", function () {
    document.addEventListener("shopify:section:load", function () {
      const announcementBarContainerDM =
        event.target.closest(".announcement-bar-new") || null;
      if (announcementBarContainerDM) {
        announcementBarSlider();
      }
      const logoListContainerDM =
        event.target.closest(".featured-logo-list") || null;
      if (logoListContainerDM) {
        logoListSlider();
      }
      const featuredCollectionContainerDM =
        event.target.closest(".featured-collection-slider") || null;
      if (featuredCollectionContainerDM) {
        featuredHomeCollectionSlider();
      }
      const testimonialSliderContainerDM =
        event.target.closest(".testimonial") || null;
      if (testimonialSliderContainerDM) {
        testimonialSlider();
      }
      const productV2MainSliderDM = event.target.closest(".product-v2") || null;
      if (productV2MainSliderDM) {
        productV2MainSlider();
      }
    });
  });
}

/****************CUSTOM DROP DOWN LAYOUT ON PDP START***********************/
$(document).ready(function () {
  $(".custom-variant-inner").click(function () {
    $(".custom-variant-inner").each(function () {
      $(this).removeClass("active-custom");
    });
    $(this).addClass("active-custom");
    var GetHTML = $(this).attr("data-name");
    $("variant-radios.no-js-hidden input[type=radio]").each(function () {
      var ValueGet = $(this).attr("value");
      console.log("ValueGet " + ValueGet);
      console.log("GetHTML " + GetHTML);
      if (ValueGet == GetHTML) {
        $(this).trigger("click");
      }
    });
  });
  $(".drop-down-list-item").click(function () {
    $(".drop-down-list-item").each(function () {
      $(this).removeClass("selected-custom");
    });
    $(this).addClass("selected-custom");
    var GetHTML = $(this).attr("data-name");
    $(".selected-variant-value").html(GetHTML);
    $("variant-radios.no-js-hidden input[type=radio]").each(function () {
      var ValueGet = $(this).attr("value");
      if (ValueGet == GetHTML) {
        $(this).trigger("click");
      }
    });
  });
  $(".selected-variant-value").click(function () {
    $(".drop-down-wrapper").addClass("custom-open");
  });
  function checkcursor() {
    if ($("#drop-down-list:hover").length != 0) {
    } else {
      $(".drop-down-wrapper").removeClass("custom-open");
    }
  }
  $(window).scroll(function () {
    if ($("#drop-down-list:hover").length != 0) {
      setTimeout(function () {
        //checkcursor();
      }, 1000);
    } else {
      //$(".drop-down-wrapper").removeClass("custom-open");
    }
  });
  $(document).on("click", function (event) {
    if (!$(event.target).closest("#drop-down-wrapper").length) {
      $(".drop-down-wrapper").removeClass("custom-open");
    }
  });
});
/****************CUSTOM DROP DOWN LAYOUT ON PDP END***********************/

$(document).ready(function () {
  // Check if the current URL contains "https://montrealweights.ca/fr"
  if (window.location.href.includes("https://montrealweights.ca/fr")) {
    // Find the link with the specific href and update it
    $('a[href="https://support.montrealweights.ca/hc/en-us"]').attr(
      "href",
      "https://support.montrealweights.ca/hc/fr-ca"
    );
  }
});

const variants = document.querySelectorAll(".drop-down-list-item");

variants.forEach((variant) => {
  variant.addEventListener("click", () => {
    const price = document.querySelector(".cc-points .cc-price");
    price.innerHTML = variant.getAttribute("data-price").slice(0, -2);
  });
});
